
export class DocumentCategoryRequirement {
    public documentCategoryTypeId: number;
    public documentCategoryType: string;
    public categoryRequirementsSatisfied: boolean;
    public documentTypeRequirementsSatisfied: boolean;
    public documentId: number;
    public documentFilename: string;
    public documentReviewStatusTypeDisplayValue: string;
    public documentReviewStatusTypeId: number;
    public documentSignatureStatusTypeDisplayValue: string;
    public documentSignatureStatusTypeId: number;
    public documentTypeId: number;
    public documentType: string;
    public loading: boolean;
    public documentReviewStatusTypes: any[] = new Array();
    public documentRequirementId: number;
    public documentRequirementTypeId: number;
    public documentRequirementType: string;
    public updateDateDisplayValue?: string;
    public documentDescription: string;
    public notificationComment: string;
    public scanLater: boolean;
    public assistedSelfServiceInvitationToken: string;
    public isAssistedSelfServiceInvitationTokenExpired: boolean;
    public isDocumentsViewRestricted: boolean;
    public isAllowDeleteScannedDocuments: boolean;

    constructor(source?: Partial<DocumentCategoryRequirement>) {
        Object.assign(this, source);
    }
}
